import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const WarningGlyph = /*#__PURE__*/createElement("g", {
  id: "warning"
}, /*#__PURE__*/createElement("path", {
  d: "M15.6,65.2c-0.1,0.1,0,0.2,0.1,0.2h52.6c0.2,0,0.2-0.1,0.1-0.2c-8.8-15.3-17.5-30.5-26.3-45.8 c-0.1-0.1-0.2-0.1-0.3,0C33.1,34.6,24.3,49.9,15.6,65.2 M71.7,64.7c1,1.7-0.2,3.8-2.2,3.8h-55c-2,0-3.2-2.1-2.2-3.8 c9.2-16,18.3-31.9,27.5-47.9c1-1.7,3.4-1.7,4.4,0C53.4,32.7,62.5,48.7,71.7,64.7"
}), /*#__PURE__*/createElement("path", {
  d: "M42,33c-1.7,0-2.5,1-2.5,2.2l0.8,14c0,1.2,0.7,2.1,1.7,2.1c0.9,0,1.7-1,1.7-2.1l0.8-14C44.5,34,43.7,33,42,33z"
}), /*#__PURE__*/createElement("path", {
  d: "M42,59.1c-0.7,0-1.3-0.2-1.8-0.7c-0.5-0.4-0.8-1.1-0.8-1.8c0-0.7,0.2-1.3,0.7-1.8c0.5-0.5,1.1-0.7,1.8-0.7 c0.7,0,1.3,0.2,1.8,0.7c0.5,0.5,0.7,1.1,0.7,1.8c0,0.8-0.2,1.4-0.7,1.8S42.7,59.1,42,59.1z"
}));
const Warning = createSvg({
  name: 'warning',
  path: WarningGlyph
});

export default Warning;
export { WarningGlyph };
